import PickerList from "components/Picker/PickerList";
import React from "react";
import { Checkbox } from "components/Atoms/inputs/Checkbox";
import { PickerListProps } from "../props";

interface Props extends PickerListProps<server.dto.ArtistSmall> {
  securityScope: server.dto.ArtistSecurityScopes;
  hideFilter1?: boolean;
}

const ArtistList = (props: Props) => {
  const [instruction, setInstruction] = React.useState<server.dto.ListArtistInstruction>({
    page: 1,
    perPage: 20,
    artistSecurityScope: props.securityScope,
    onlyFavorite: false,
    keyword: "",
    profile: "onlyActive",
  });

  const setFilter = (profile: server.dto.IsArtistTypeFilterOptions) => { setInstruction(instr => ({ ...instr, profile, page: 1 })); };

  const setOnlyFavorite = (onlyFavorite: boolean) => { setInstruction(instr => ({ ...instr, onlyFavorite, page: 1 })); };

  const isExternalUser = site.currentEnvironment.type === "external";
  const hideFilter1 = props.hideFilter1 || isExternalUser;

  return <PickerList
    instruction={instruction}
    onInstructionChange={newInstruction => setInstruction(newInstruction)}
    queryKey="artistpickerlist"
    api={window.CoreApi.Artist.PaginatedSmall}
    onClick={props.onItemSelected}

    getError={() => undefined}
    excludeKeys={props.excludeKeys}
    getId={artist => artist.artistId}
    renderListItem={artist => <div>{artist.name}</div>}
    hideKeywordFilter={isExternalUser}
    filter1={hideFilter1 ? undefined : {
      leftButton: {
        type: "primary",
        isActive: instruction.profile === "onlyActive",
        label: RESX.SoUser.Active,
        onClick: () => { setFilter("onlyActive"); }
      },
      rightButton: {
        type: "primary",
        isActive: instruction.profile === "onlyNoLongerActive",
        label: RESX.SoUser.Deactivated,
        onClick: () => { setFilter("onlyNoLongerActive"); }
      }
    }}
    otherFilters={isExternalUser ? undefined : <Checkbox label={RESX.GeneralLabels.OnlyFavorites} checked={instruction.onlyFavorite} onChange={(_, checked) => setOnlyFavorite(checked)} />}
  />;
};

export default ArtistList;